import React from 'react';

const VARIANTS = {
  default: 'tw1-heroBand-default',
  ing: 'tw1-heroBand-ing',
  truckshop: 'tw1-heroBand-truckshop',
  ptw: 'tw1-heroBand-ptw',
  teal: 'tw1-heroBand-teal',
  emerald: 'tw1-heroBand-emerald',
  indigo: 'tw1-heroBand-indigo',
};

export default function HeroBanner({ title, subtitle, variant = 'default', actions, icon: Icon, logos }) {
  return (
    <div className={`${VARIANTS[variant] || VARIANTS.default} rounded-2xl px-6 py-5 mb-6`} data-testid="hero-banner">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-4">
          {Icon && (
            <div className="w-11 h-11 rounded-xl bg-white/80 flex items-center justify-center shadow-sm">
              <Icon className="w-5 h-5 text-[#003366]" />
            </div>
          )}
          <div>
            <h1 className="text-xl font-bold text-[#0b1220] tracking-tight">{title}</h1>
            {subtitle && <p className="text-sm text-[#526071] mt-0.5">{subtitle}</p>}
          </div>
        </div>
        <div className="flex items-center gap-3">
          {logos && logos.length > 0 && (
            <div className="hidden sm:flex items-center gap-3" data-testid="hero-logos">
              {logos.map((logo, i) => (
                <img key={i} src={logo.src} alt={logo.alt} className="h-8 w-auto opacity-80" style={{ filter: variant === 'truckshop' ? 'drop-shadow(0 0 4px rgba(255,255,255,0.3))' : 'none' }} />
              ))}
            </div>
          )}
          {actions && <div className="flex items-center gap-2">{actions}</div>}
        </div>
      </div>
    </div>
  );
}
